function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.25 14.899A6.32 6.32 0 0018.547 12 6.347 6.347 0 0122 17.648 6.352 6.352 0 0115.648 24 6.346 6.346 0 0110 20.546c.87.448 1.853.705 2.898.705a6.352 6.352 0 006.353-6.352z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 1a3 3 0 00-2.959 2.5H11.5A1.5 1.5 0 0010 5H7a2 2 0 00-2 2v22a2 2 0 002 2h18a2 2 0 002-2V7a2 2 0 00-2-2h-3a1.5 1.5 0 00-1.5-1.5h-1.541A3 3 0 0016 1zm1 3a1 1 0 10-2 0 1 1 0 01-1 1h-1.5a.5.5 0 00-.5.5v.4a.1.1 0 00.1.1h7.8a.1.1 0 00.1-.1v-.4a.5.5 0 00-.5-.5H18a1 1 0 01-1-1zm-6 4a1 1 0 01-1-1H7.5a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-21a.5.5 0 00-.5-.5H22a1 1 0 01-1 1H11z",
  fill: "currentColor"
})));